import { StorageKeys } from '@/modules/common/services/local-storage';

export const shouldRedirectToSuitability = () => {
  return !!localStorage.getItem(StorageKeys.FastRegisterSuitability);
};

export const isSuitabilityPending = () => {
  return !!localStorage.getItem(StorageKeys.FastRegisterSuitability);
};
